let awsAudioMap = {};

export const setAwsAudio = (audioMap) => { awsAudioMap = audioMap; };
export const getAwsAudio = () => awsAudioMap;
